module.exports = __webpack_public_path__ + "media/images/flags/kg-350173f1f81b3455bc43fea609105a97.svg";